<template>
    
    <div class="w-full flex space-x-2 py-2 cursor-pointer select-none" @click="input = !input" >

        <div class="w-6 min-w-6 h-6 flex items-center justify-center border border-solid border-gray-400 rounded-full" >

            <img src="/images/icons/check-green.svg" alt="checkmark" class="transform scale-0 transition-transform duration-100" :class="{ 'scale-100': input }" >

        </div>

        <div class="flex-grow" >

            <p class="text-sm tracking-widest" >{{ label }}</p>

        </div>

    </div>

</template>

<script>

    import { ref, computed } from 'vue'

    export default {
    
        name: 'Checkbox',

        props: {
            label: String,
            modelValue: Boolean
        },

        setup( props, { emit } ) {

            const input = computed({
                get: () => props.modelValue,
                set: value => emit( 'update:modelValue', value )
            })

            return {
                input
            }

        }

    }

</script>